import {
  WSCard,
  WSElement,
  WSSectionToolbar,
  WSText,
  WSTimeline,
  WSTimelineItemProps
} from "@wingspanhq/fe-component-library";
import React from "react";

type Props = {
  /** Built from real run lifecycle events — see `selectorPayrollRunHistoryItems`. */
  items: WSTimelineItemProps[];
  onViewAll?: () => void;
};

export const RecentHistoryWidget: React.FC<Props> = props => (
  <WSElement>
    <WSSectionToolbar
      button={
        props.onViewAll
          ? { label: "View all", onClick: props.onViewAll }
          : undefined
      }
      title="Recent history"
    />
    <WSCard mt="M">
      {props.items.length === 0 ? (
        <WSText.ParagraphSm color="gray500">
          No payroll activity yet.
        </WSText.ParagraphSm>
      ) : (
        <WSTimeline items={props.items} />
      )}
    </WSCard>
  </WSElement>
);
